import { render, staticRenderFns } from "./GerenciamentoTabelasBasicas.vue?vue&type=template&id=4b600a00&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciamentoTabelasBasicas.vue?vue&type=style&index=0&id=4b600a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b600a00",
  null
  
)

export default component.exports